'use client';
import AppLayout from '@/components/AppLayout';
import AlertasScreen from './components/AlertasScreen';

export default function AlertasPage() {
  return (
    <AppLayout>
      <AlertasScreen />
    </AppLayout>
  );
}
